export const GET_HNIR_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_HNIR_REQUEST";
export const GET_HNIR_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_HNIR_SUCCESS";
export const GET_HNIR_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_HNIR_FAILURE";
